export default "__VITE_ASSET__BMjrCs2U__"